/**
 * Gameplay invariant for Prize Shot: one physical cannon ball may award at
 * most one balloon, regardless of how many times it bounces afterwards.
 */
export class PrizeShotHitLimiter<TProjectile extends object>
{
  private readonly consumed = new WeakSet<TProjectile>();

  /** Returns the hit cell once, then rejects every later hit by this projectile. */
  public consume( projectile: TProjectile, cell: number | null ): number | null
  {
    if ( cell === null || this.consumed.has( projectile ) )
      return null;

    this.consumed.add( projectile );
    return cell;
  }

  /** The projectile missed (bounced off something): it may not award anything afterwards. */
  public markMissed( projectile: TProjectile ): void
  {
    this.consumed.add( projectile );
  }

  public hasConsumed( projectile: TProjectile ): boolean
  {
    return this.consumed.has( projectile );
  }
}
